import SsoAuth from './components/SsoAuth';
import NotFound from '@/components/elements/NotFound';
import NotAllowed from './components/NotAllowed';

export default [
  {
    path: '/auth',
    name: 'auth',
    component: SsoAuth,
    meta: {
      title: 'Auth',
      requiresAuth: false,
      hideSidebar: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: NotFound,
    meta: {
      requiresAuth: false,
      title: '404 Not Found',
      hideSidebar: true
    }
  },
  {
    path: '/auth/403',
    name: 'notAllowed',
    props: true,
    component: NotAllowed,
    meta: {
      title: 'Not Allowed',
      bypassOrgCheck: true,
      requiresAuth: true,
      hideSidebar: true
    }
  }
];
